import * as Css from "./style";
import { zafClient } from "../../service/zendesk";
// @ts-ignore
import { RawForm } from "@BCR-CX/zendesk-form";
import ButtonDefault from "../../ui/Button";
import { useForm } from "./useForm";
interface FormProps {
  handleSubmit: (field: string, value: string) => void;
  handleSubject: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleComment: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handleTypeComment: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  handleStatus: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  handleType: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  handlePriority: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  handleUpdateTickets: () => void;
  updating: boolean;
  updateProgress: number;
  results: Record<string, string>[];
  resetForm?: () => void;
  failedTickets?: any[];
  exportFailedTicketsToXLSX?: () => void;
}

const UpdateTicketForm: React.FC<FormProps> = ({
  handleSubmit,
  handleSubject,
  handleComment,
  handleTypeComment,
  handleType,
  handlePriority,
  handleUpdateTickets,
  updating,
  updateProgress,
  results,
  resetForm,
  failedTickets,
  exportFailedTicketsToXLSX,
}) => {

  const { statuses } = useForm();

  return (
    <Css.TicketFormContainer>
      <Css.TicketHeaderTitle>
        <h2>Formulário de ticket</h2>
      </Css.TicketHeaderTitle>

      {failedTickets && failedTickets.length > 0 && (
        <Css.FailedTicketsAlert>
          <p>{failedTickets.length} tickets não foram atualizados.</p>
          <ButtonDefault
            title="Baixar relatório de erros"
            onClick={exportFailedTicketsToXLSX!}
            color="#DC2626"
            textColor="white"
          />
        </Css.FailedTicketsAlert>
      )}

      <Css.TicketForm>
        <p>Status do ticket</p>
        <select
          onChange={(e) => {
            const value = e.target.value;
            const selectedStatus = statuses.find(s => s.id.toString() === value);
            if (selectedStatus && selectedStatus.type === "custom") {
              handleSubmit("status", selectedStatus.status_category);
              handleSubmit("custom_status_id", value);
            } else {
              handleSubmit("status", value);
            }
          }}
        >
          <option value="-">-</option>
          {statuses
            .filter(status => status.agent_label?.trim() !== "")
            .map((status) => (
              <option key={status.id} value={status.id}>
                {status.agent_label || status.name}
              </option>
            ))}
        </select>
        <p>Tipo do ticket</p>
        <select onChange={handleType}>
          <option value="-">-</option>
          <option value="pergunta">Pergunta</option>
          <option value="incidente">Incidente</option>
          <option value="problema">Problema</option>
          <option value="tarefa">Tarefa</option>
        </select>
        <p>Prioridade</p>
        <select onChange={handlePriority}>
          <option value="-">-</option>
          <option value="low">Low (Baixa)</option>
          <option value="normal">Normal</option>
          <option value="high">High (Alta)</option>
          <option value="urgent">Urgent (Urgente)</option>
        </select>
        <p>Assunto</p>
        <Css.SubjectInput
          type="text"
          placeholder="Informe o assunto do ticket:"
          onChange={(e) => {
            handleSubject(e);
          }}
        />
        <p>Solicitante (email)</p>
        <Css.SubjectInput
          type="email"
          placeholder="Email do solicitante"
          onChange={(e) => handleSubmit("requester_email", e.target.value)}
        />
        <p>Comentário</p>
        <select
          onChange={(e) => {
            handleTypeComment(e);
          }}
        >
          <option value="-">-</option>
          <option value="public">Público</option>
          <option value="locked">Privado</option>
        </select>
        <textarea
          placeholder="Comentário:"
          onChange={(e) => {
            handleComment(e);
          }}
        />

        <RawForm client={zafClient} onChange={handleSubmit} />
      </Css.TicketForm>
      <Css.FooterTicket>
        <ButtonDefault border disabled={!results.length || updating} title="Desfazer alterações" onClick={() => resetForm} color="transparent" textColor="#2F5BFF" />
        <ButtonDefault disabled={!results.length || updating} color="#2F5BFF" textColor="white" title={updating ? `Atualizando... ${updateProgress}/${results.length}` : "Atualizar tickets"} onClick={handleUpdateTickets} />
      </Css.FooterTicket>
    </Css.TicketFormContainer>
  );
};

export default UpdateTicketForm;
